import Acl from "./acl";
import Keycloak from "./keycloak";

// Do more security things here
export default ({ children }) =>
    <Keycloak><Acl>{children}</Acl></Keycloak>;
